export function pickupDeltaPoints(
  price: number | null | undefined,
  lockedPrice: number | null | undefined
): number | null {
  if (price === null || price === undefined || lockedPrice === null || lockedPrice === undefined) {
    return null;
  }
  const nextPrice = Number(price);
  const baseline = Number(lockedPrice);
  if (!Number.isFinite(nextPrice) || !Number.isFinite(baseline)) {
    return null;
  }
  return Number((nextPrice - baseline).toFixed(3));
}

/** Canonical display/export rule for potential Pick Up revenue. */
export function pickupPointsToDollars(
  points: number | null | undefined,
  loanAmount: number | null | undefined
): number | null {
  if (points === null || points === undefined || loanAmount === null || loanAmount === undefined) {
    return null;
  }
  const nextPoints = Number(points);
  const amount = Number(loanAmount);
  if (!Number.isFinite(nextPoints) || !Number.isFinite(amount)) {
    return null;
  }
  return Math.round((nextPoints * amount) / 100);
}
